module.exports = __webpack_public_path__ + "static/media/lion.0810626c.svg";